<template>
  <b-form-row>
    <lg-finder ref="finder" :id="this.id" :fields="fields" title="Busca tipo estado conservação"
      url="/api/tipo-estado-conservacao" filterBy="nome" :othersFilters="othersFilters" @onSelect="onSelect"
      filtrarSituacao />
  </b-form-row>
</template>
<script>

import LgFinder from "@/core/components/Inputs/LgFinder.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";


export default {
  components: { LgFinder, LgFormInputFinder, },
  props: {
    id: String,
    title: String
  },
  data() {
    return {
      fields: [
        {
          key: "descricao",
          label: "Descrição",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 col-4",
        },

        {
          key: "situacao",
          label: "Situação",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 col-1",
        },
      ],
      othersFilters: []
    };
  },

  async mounted() {
    this.othersFilters = [
    ]
  },

  methods: {
    async show() {
      await this.$refs.finder.show();
      this.othersFilters.forEach(item => item.filter = '')
    },

    async onSelect(item) {
      this.$emit("onSelect", item);
      await this.$bvModal.hide(this.id);

    },
  },
};
</script>
